// import { logDOM } from '@testing-library/react';
import { atom } from 'jotai';

export const sheetData = atom(null);
export const airesponse = atom([]);
export const length = atom(null);
export const ouputar = atom(null);
export const selectdata = atom([]);
export const insertDirectionAtom = atom(null);
export const tableNameAtom = atom('Web Researcher Tool');
// Atom for the row index
export const rowIndexAtom = atom('');
export const keywordAtom = atom('');

// Atom for the column index
export const colIndexAtom = atom('');

// Atom for AI response columns
export const aiResponseColumnsAtom = atom('');
console.log('from atom length',length);
console.log('from atom file sheetData', sheetData);
console.log('from airesponse file sheetData', airesponse);
console.log('from keyword file sheetData', keywordAtom);





